module.exports = __webpack_public_path__ + "img/rabren-logo.cf5159de.jpg";